import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** Centred result page: logo on top, one raised panel. */
export function StatusPage({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center px-4 py-12">
      <img
        src="/ywc21/logo-compass.webp"
        alt="Young Webmaster Camp 21st"
        width={488}
        height={319}
        className="mb-8 h-16 w-auto sm:h-20"
      />
      <div
        className={cn(
          'w-full max-w-[640px] rounded-ds-md border border-line bg-surface-raised/85 px-6 py-10 text-center sm:px-12',
          className
        )}
      >
        {children}
      </div>
    </main>
  )
}

/** Paper note on the night sky — the design system's ParchmentCard material. */
export function ParchmentNote({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('parchment-frame text-left text-parchment-ink', className)}>
      <div className="px-5 py-4 sm:px-7 sm:py-5">{children}</div>
    </div>
  )
}

export const parchmentLinkClassName =
  'font-semibold text-navy underline decoration-navy/40 underline-offset-4 hover:decoration-navy'

export const inkLinkClassName =
  'font-medium text-ink underline decoration-line underline-offset-4 transition-colors hover:decoration-ink'
